import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SnackbarService } from '@bcl/design-system';
import { Platform } from '@ionic/angular';
import { VisitService } from 'src/app/services/visit.service';
import { BaseAreaAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-area-details-summary',
  templateUrl: './area-details-summary.component.html',
  styleUrls: ['./area-details-summary.component.scss'],
})
export class AreaDetailsSummaryComponent
  extends BaseAreaAccordionComponent
  implements OnInit
{
  @Input() area;
  @Input() visitId;
  @Input() visit?: any; // Add visit input
  @Input() isEditingDisabled = false;
  public form: FormGroup;
  public initialMemo: string | null = null;

  constructor(
    private fb: FormBuilder,
    private visitService: VisitService,
    private snackbarService: SnackbarService,
    public platform: Platform,
    accordionService: AccordionService
  ) {
    super(accordionService);
    this.form = this.fb.group({
      areaSummary: [null],
    });

    this.form.get('areaSummary')?.valueChanges.subscribe((value) => {
      this.area.summary = value;
    });
  }

  // Computed property to check if form should be disabled
  get isFormDisabled(): boolean {
    return this.isEditingDisabled;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.form.patchValue({ areaSummary: this.area.summary ?? null });
    this.initialMemo = this.area.summary ?? null;

    // Disable form if visit is completed and not reopened
    if (this.isFormDisabled) {
      this.form.disable();
    }
  }
  public setMemo(desc: string) {
    this.form.get('areaSummary')?.setValue(desc);
    this.form.markAsDirty();
  }
  public saveMemo() {
    const formValue = this.form.value;

    // Only save if visit is not completed and summary is not empty
    if (
      !this.isFormDisabled &&
      formValue.areaSummary &&
      formValue.areaSummary.trim() !== ''
    ) {
      this.visitService
        .updateField(
          'PestControl.Areas',
          this.area.id,
          formValue.areaSummary,
          'Summary',
          this.visitId
        )
        .subscribe({
          next: () => {
            this.snackbarService.open(
              'green',
              'AREA.DETAILS.SUMMARY.MESSAGES.SUMMARY_SAVED'
            );
          },
          error: () => {
            this.snackbarService.open(
              'red',
              'GENERIC_ERROR_MESSAGES.AN_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER'
            );
          },
        });
    }
  }
}
